import { BrandId } from './brand.types';
export function resolveBrandFromHost(hostname: string): BrandId {
  const host = hostname.toLowerCase();

  if (host.startsWith('hail.')) return 'hail';
  if (host.startsWith('zeva.')) return 'zeva';

  // prod/test
  if (host === 'app.ridehail.app' || host === 'test.ridehail.app') return 'hail';
  if (host === 'app.zevaglobal.com' || host === 'test.zevaglobal.com') return 'zeva';

  return 'zeva';
}
